<template>
  <b-modal
        scrollable
    id="add-article-order-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="xl"
    :title="$t('AddArticles')"
    hide-footer
    @hide="onCancel"
  >
    <b-tabs>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("ExistingArticles") }}</strong>
        </template>
        <ExistingArticlesOverview />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ExistingArticlesOverview from './ExistingArticlesOverview.vue';


export default {
  components: {
    ExistingArticlesOverview,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions(['addMainDressCategory', 'addInventoryProductSize', 'addColorToMainDressCategoryById']),
    onCancel() {
      this.$refs.modal.hide()
      this.onReset()
    },
    onReset() {
    },
  },
}
</script>

<style lang="scss" scoped>
.team_table td {
  padding: 16px 9px !important;
}
</style>
